export const degreeStreamPayload = data => {
  const returnData = data?.flatMap(degree => {
    if (degree?.streams?.length > 0) {
      return degree.streams.map(stream => ({
        degreeId: degree.degreeId,
        streamId: stream,
      }))
    }
    return {
      domainId: degree.degreeId,
    }
  })
  return returnData
}

export const labelChangeFunction = label => {
  switch (label) {
    case 'PLACEMENT':
      return 'Placement'
    case 'INTERNSHIP':
      return 'Internships'
    case 'APPRENTICESHIP':
      return 'Apprenticeship'
    case 'GIGS':
      return 'Gigs'
  }
}

export const jobCategoryFilterData = data => {
  if (data?.length > 0) {
    let jobCat = data.map(item => ({
      label: labelChangeFunction(item),
      value: item,
    }))
    return jobCat
  }
}

export const jobCategoryData = [
  'PLACEMENT',
  'INTERNSHIP',
  'APPRENTICESHIP',
  'GIGS',
]

export const getPlacedStatus = status =>
  status === 'INTENT_TO_OFFER' ? 'Intent to Offer' : 'Offer Acceptance'

export const formatNumber = num => {
  if (!num) return ''

  // Clean the input to remove non-digit characters
  const cleaned = num.toString().replace(/\D/g, '')

  // Handle the case for formatting
  const lastThreeDigits = cleaned.slice(-3)
  const otherDigits = cleaned.slice(0, -3)

  // Add commas to the main part of the number
  let formattedNumber = otherDigits.replace(/\B(?=(\d{2})+(?!\d))/g, ',')

  // Concatenate the last three digits and return
  return formattedNumber + (formattedNumber ? ',' : '') + lastThreeDigits
}

export const checkFormatNumber = value => {
  const parsed = value?.replace(/\$\s?|(,*)/g, '') // Remove "$" and commas
  return !isNaN(parsed) && parsed.trim() !== '' ? parsed : undefined // Ensure valid number
}

export const convertToNumber = formattedValue => {
  if (formattedValue === null || formattedValue === undefined) return 0 // Handle empty or null values

  // Convert value to string if it isn't already a string
  const valueAsString = String(formattedValue)

  // Remove commas (if any) and parse the number
  const cleanedValue = valueAsString.replace(/,/g, '') // Remove commas if any
  const numericValue = parseFloat(cleanedValue) // Convert to number

  return isNaN(numericValue) ? 0 : numericValue
}

export const handleKeyDown = e => {
  // Allow only numbers, backspace, and delete keys
  if (!/[0-9]/.test(e.key) && e.key !== 'Backspace' && e.key !== 'Delete') {
    e.preventDefault()
  }
}

export function formatCTC(value, addSuffix = false) {
  if (addSuffix) {
    return formatNumber(value)
  }
  if (value >= 1000 && value < 100000) {
    // Convert to K format: divide by 1000 and add 'K'
    const kValue = Math.floor(value / 1000)
    return kValue + 'K'
  } else if (value >= 100000 && value <= 99999999) {
    // Convert to LPA format: divide by 100000 and add 'LPA'
    const lpaValue = Math.floor(value / 100000)
    return lpaValue + ' LPA'
  }
  return value
}

export const allMonths = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
]

export const formatWithHyphens = date => {
  const d = new Date(date)
  const day = String(d.getDate()).padStart(2, '0')
  const month = String(d.getMonth() + 1).padStart(2, '0') // Months are zero-based
  const year = d.getFullYear()
  return `${day}/${month}/${year}`
}

export const initialRoleApplyPermit = {
  roleCount: '',
  isEnabled: false,
}
export const initialAbsentCount = {
  missedEvaluationCount: '',
  isEnabled: false,
}

export const initialMaxRolesAllowed = {
  roleCount: '',
  isEnabled: false,
}

export const initialCTCRule = {
  compensation: '',
  isEnabled: false,
  closestCtcRate: '',
  allowClosestCTC: false,
}

export const initialDurationRange = {
  isEnabled: false,
  duration: '',
  tenureRange: [
    {
      isEnabled: false,
      startMonth: null,
      endMonth: null,
    },
  ],
}
